<template>
    <div>
        <vTable 
            class="margin-15"
            :columns="columns"
            :data="datalist"
            size="small"
            ref="tabledoc"
            border>
        </vTable>
        <div class="text-right margin-right-15">
            <Button type="primary" @click="submit">确认</Button>
            <Button class="margin-left-5" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
    export default {
        props:['linelist','chooseItem','chooselist'],
        data(){
            return{
                checkList:[],
                datalist:[],
            }
        },
        created(){
            this.linelist.map(item=>{
                this.datalist.push(item)
            })
            this.chooselist.map(item=>{
                if(item.value === this.chooseItem.value){
                    this.checkList = item.items
                }
            })
            if(this.checkList){
                this.datalist.map(item=>{
                    this.checkList.map(json=>{
                        if(item.value === json.billingCategoryId){
                            item.ischeck = true
                        }
                    })
                })
            }

        },
        computed:{
            columns(){
                return [
                    {
                        align:'center',
                        renderHeader:(h,params)=>{
                        return h('div',[
                            h('div',{
                            },[
                                h('vCheckbox',{
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                        'on-change':(value)=>{
                                            this.datalist.map(item=>{
                                                this.$set(item,'ischeck',value)
                                            })
                                            
                                        },
                                    },
                                }),
                            ])
                        ])
                    },
                        render:(h,{row,index})=>{
                            return h('vCheckbox',{
                                props:{
                                    value: row.ischeck,
                                },
                                on: {
                                    'on-change':(value) => {
                                        this.datalist[index].ischeck = value
                                    }
                                },
                            })
                        }
                    },
                    {
                        title:'计费项目',
                        key:'label'
                    }
                ]
            }
        },
        methods:{
            submit(){
                let newarr = [];
                this.datalist.map(item=>{
                    if(item.ischeck){
                        let json = {
                            billingCategoryId:item.value,
                            billingCategoryCode:item.attach.code,
                            orderType:this.chooseItem.value,
                        }
                        newarr.push(json)
                    }
                })
                this.$emit('on-update',newarr)
            },
            cancel(){
                this.$emit('on-close')
            }
        }
    }
</script>
